/**
 * 管理下拉菜单的访问状态
 * 用于记录用户是否已经访问过下拉菜单组件
 */
export const useDropdownMenu = () => {
    // 使用 useState 创建全局状态，key 为 'dropdown-menu-visited'
    const hasVisited = useState<boolean>('dropdown-menu-visited', () => false)
    
    /**
     * 标记为已访问
     */
    const markAsVisited = () => {
        hasVisited.value = true
    }
    
    /**
     * 检查是否已访问
     */
    const isVisited = () => {
        return hasVisited.value
    }
    
    /**
     * 重置访问状态（如果需要）
     */
    const resetVisited = () => {
        hasVisited.value = false
    }
    
    return {
        hasVisited,
        markAsVisited,
        isVisited,
        resetVisited
    }
}

